<template>
  <div>
    <ConsoleLogOutput ref="ConsoleLogOutput"></ConsoleLogOutput>
    <JenkinsBuild ref="JenkinsBuild" v-on:buildComplete="jenkinsBuildComplete"></JenkinsBuild>
    <Modal v-model="updateNumberModal">
      <div style="padding: 20px">
        <Alert show-icon>如果你已经构建过此模块，请填入构建号，避免重复构建</Alert>
        <InputNumber v-model="updateNumber" style="width: 100%" :min="1" placeholder="请填入构建号" />
      </div>
      <div slot="footer">
        <Button type="primary" :loading="updateNumberSubmitting" @click="updateNumberSubmit">构建</Button>
        <Button @click="updateNumberModal = false">取消</Button>
      </div>
    </Modal>
    <Alert v-if="error" type="warning" show-icon>获取数据失败</Alert>
    <div v-else-if="table.testData.length || table.productData.length">
      <div v-if="table.testData.length">
        <Alert show-icon>测试环境</Alert>
        <Table
          class="code-release-build-task-table"
          highlight-row
          :loading="tableLoading"
          ref="table"
          :data="table.testData"
          :columns="table.columns"></Table>
      </div>
      <div style="margin-top: 10px" v-if="table.productData.length">
        <Alert show-icon type="warning">生产环境</Alert>
        <Table
          class="code-release-build-task-table"
          highlight-row
          :loading="tableLoading"
          ref="table"
          :data="table.productData"
          :columns="table.columns"></Table>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { getCodeReleaseFlowBuildTasks, updateCodeReleaseFlowBuildTaskBuildNumber,
  cancelBuildCodeReleaseFlowBuildTasks,
  cancelQueueCodeReleaseFlowBuildTasks } from '@/api/workflow/code_release_flow'
import JenkinsBuild from './start-build'
import ConsoleLogOutput from '@/view/tools/jenkins/components/console-output'

export default {
  name: 'build',
  components: {
    JenkinsBuild,
    ConsoleLogOutput
  },
  props: {
    jobFlowId: null
  },
  data () {
    return {
      showModal: false,
      error: false,
      jobFlow: {},
      tableLoading: false,
      updateNumber: null,
      updateNumberTaskId: '',
      updateNumberModal: false,
      updateNumberSubmitting: false,
      table: {
        testData: [],
        productData: [],
        columns: [
          // {
          //   title: '模块名',
          //   key: 'module_name',
          //   align: 'center',
          //   tooltip: true,
          //   minWidth: 130
          // },
          {
            title: '环境',
            key: 'scenes_verbose',
            align: 'center',
            tooltip: true,
            minWidth: 100
          },
          {
            title: 'Jenkins Job',
            key: 'jenkins_job',
            align: 'center',
            tooltip: true,
            minWidth: 130
          },
          {
            title: '构建号',
            key: 'number',
            align: 'center',
            tooltip: true,
            minWidth: 80,
            render: (h, params) => {
              if (params.row.number) {
                return h('a', {
                  on: {
                    click: () => {
                      this.$refs.ConsoleLogOutput.getOutput(params.row.jenkins_id, params.row.jenkins_job, params.row.number)
                    }
                  }
                }, '#' + params.row.number)
              }
            }
          },
          {
            title: '构建类型',
            key: 'type_verbose',
            align: 'center',
            tooltip: true,
            minWidth: 90
          },
          {
            title: '状态',
            key: 'status_verbose',
            align: 'center',
            tooltip: true,
            minWidth: 120,
            render: (h, params) => {
              if (params.row.status_verbose) {
                return h('Tag', {
                  props: {
                    color: params.row.status_verbose === '构建成功' ? 'green'
                      : params.row.status_verbose === '构建失败' ? 'red'
                        : params.row.status_verbose === '已终止' ? 'orange'
                          : params.row.status_verbose === '构建中' ? 'blue'
                            : params.row.status_verbose === '队列中' ? 'blue'
                              : params.row.status_verbose === '未构建' ? 'default'
                                : 'blue'
                  }
                }, params.row.status_verbose)
              } else {
                return ''
              }
            }
          },
          {
            title: '构建时间',
            key: 'built_at',
            align: 'center',
            tooltip: true,
            minWidth: 100,
            render: (h, params) => {
              if (params.row.built_at) {
                return h('span', moment(params.row.built_at).format('YYYY-MM-DD HH:mm:ss'))
              } else {
                return ''
              }
            }
          },
          {
            title: '构建用户',
            key: 'build_user',
            align: 'center',
            tooltip: true,
            minWidth: 100,
            render: (h, params) => {
              return h('span', params.row.build_user.name ? params.row.build_user.name : params.row.build_user.username)
            }
          }
          // {
          //   title: '操作',
          //   align: 'center',
          //   fixed: 'right',
          //   width: 150,
          //   render: (h, params) => {
          //     // return h('div', [
          //     //   h('Button', {
          //     //     props: {
          //     //       type: 'primary',
          //     //       size: 'small',
          //     //       loading: params.row.status === 'in_queue' || params.row.status === 'building',
          //     //       disabled: !params.row.can_build
          //     //     },
          //     //     style: {
          //     //       marginRight: '5px',
          //     //       display: params.row.can_build ? 'inline-block' : 'none'
          //     //     },
          //     //     on: {
          //     //       click: () => {
          //     //         this.$refs.JenkinsBuild.start(params.row.jenkins_id, params.row.jenkins_job, params.row.id)
          //     //       }
          //     //     }
          //     //   }, '控制台')
          //       // h('Button', {
          //       //   props: {
          //       //     type: 'primary',
          //       //     size: 'small',
          //       //     loading: params.row.status === 'in_queue' || params.row.status === 'building',
          //       //     disabled: !params.row.can_build
          //       //   },
          //       //   style: {
          //       //     marginRight: '5px',
          //       //     display: params.row.can_build ? 'inline-block' : 'none'
          //       //   },
          //       //   on: {
          //       //     click: () => {
          //       //       this.$refs.JenkinsBuild.start(params.row.jenkins_id, params.row.jenkins_job, params.row.id)
          //       //     }
          //       //   }
          //       // }, '构建'),
          //       // h('Button', {
          //       //   props: {
          //       //     type: 'error',
          //       //     size: 'small'
          //       //   },
          //       //   style: {
          //       //     marginRight: '5px',
          //       //     display: params.row.can_cancel_build ? 'inline-block' : 'none'
          //       //   },
          //       //   on: {
          //       //     click: () => {
          //       //       this.cancelBuild(params.row.id)
          //       //     }
          //       //   }
          //       // }, '取消构建'),
          //       // h('Button', {
          //       //   props: {
          //       //     type: 'error',
          //       //     size: 'small'
          //       //     // loading: true
          //       //   },
          //       //   style: {
          //       //     marginRight: '5px',
          //       //     display: params.row.can_cancel_queue ? 'inline-block' : 'none'
          //       //   },
          //       //   on: {
          //       //     click: () => {
          //       //       this.cancelQueue(params.row.id)
          //       //     }
          //       //   }
          //       // }, '取消队列'),
          //       // h('Button', {
          //       //   props: {
          //       //     type: 'error',
          //       //     size: 'small',
          //       //     loading: params.row.status === 'in_queue' || params.row.status === 'building',
          //       //     disabled: !params.row.can_rollback
          //       //   },
          //       //   style: {
          //       //     marginRight: '5px',
          //       //     display: params.row.can_rollback ? 'inline-block' : 'none'
          //       //   },
          //       //   on: {
          //       //     click: () => {
          //       //       this.$refs.JenkinsBuild.start(params.row.jenkins_id, params.row.jenkins_job, params.row.id, 'rollback')
          //       //     }
          //       //   }
          //       // }, '回滚')
          //     // ])
          //   }
          // }
        ]
      },
      moment: moment,
      buildTasksTimer: null
    }
  },
  created: function () {
    this.init()
  },
  watch: {
    '$route' () {
      if (this.$route.params.id) {
        this.init()
      }
    }
  },
  beforeDestroy () {
    clearInterval(this.buildTasksTimer)
    this.buildTasksTimer = null
  },
  methods: {
    // 打开对话框
    init () {
      // this.getJobFlow()
      this.getBuildTasks()
      this.showModal = true
      this.setBuildTasksTimer()
    },
    // 关闭对话框
    closeModal () {
      clearInterval(this.buildTasksTimer)
      this.buildTasksTimer = null
    },
    // 获取构建任务列表
    getBuildTasks () {
      this.tableLoading = true
      getCodeReleaseFlowBuildTasks(this.jobFlowId).then(res => {
        this.table.testData = []
        this.table.productData = []
        for (let i in res.data) {
          if (res.data[i].scenes === 'test') {
            this.table.testData.push(res.data[i])
          } else if (res.data[i].scenes === 'product') {
            this.table.productData.push(res.data[i])
          }
        }
        // 判断job是否都已经构建完毕，删掉定时器
        if (this.table.productData.filter(item => ['not_build', 'in_queue', 'building'].indexOf(item.status) > -1).length === 0) {
          this.closeModal()
        }
        this.error = false
        this.tableLoading = false
      }).catch(res => {
        console.log(res.response)
        this.error = true
        this.tableLoading = false
      })
    },
    // Jenkins构建完成
    jenkinsBuildComplete (jobName, queueNumber, taskId) {
      this.getBuildTasks()
    },
    // 自动获取构建队列
    setBuildTasksTimer () {
      clearInterval(this.buildTasksTimer)
      this.buildTasksTimer = null
      if (this.buildTasksTimer == null) {
        this.buildTasksTimer = setInterval(() => {
          this.getBuildTasks()
        }, 10000)
      }
    },
    // 手动填入构建号
    updateNumberSubmit () {
      if (!this.updateNumber) {
        this.$Notice.error('构建号不能为空')
        return
      }
      this.updateNumberSubmitting = true
      updateCodeReleaseFlowBuildTaskBuildNumber(this.updateNumberTaskId, this.updateNumber).then(res => {
        this.$Notice.success({ title: '操作成功' })
        this.updateNumberModal = false
        this.updateNumberSubmitting = false
      }).catch(res => {
        this.updateNumberSubmitting = false
        console.log(res.response)
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！',
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '操作失败！'
          })
        }
      })
    },
    // 取消构建
    cancelBuild (id) {
      cancelBuildCodeReleaseFlowBuildTasks(id).then(res => {
        if (res.data.result === 'ok') {
          this.$Notice.success({ title: '操作成功' })
          this.getBuildTasks()
        }
      }).catch(res => {
        console.log(res.response)
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！',
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '操作失败！'
          })
        }
      })
    },
    // 取消队列
    cancelQueue (id) {
      cancelQueueCodeReleaseFlowBuildTasks(id).then(res => {
        if (res.data.result === 'ok') {
          this.$Notice.success({ title: '操作成功' })
          this.getBuildTasks()
        }
      }).catch(res => {
        console.log(res.response)
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！',
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '操作失败！'
          })
        }
      })
    }
  }
}
</script>

<style lang="less">
  .code-release-build-task-table {
    .ivu-table-overflowX {
      padding: 0;
      overflow-y: auto;
      max-height: 250px;
      padding-bottom: 5px;
    }
    .ivu-table-overflowX::-webkit-scrollbar {
      height: 5px;
    }
    .ivu-table-overflowX::-webkit-scrollbar-track {
      border-radius: 5px;
      background-color: #eee;
    }
    .ivu-table-overflowX::-webkit-scrollbar-thumb {
      border-radius: 5px;
      background: #dbdbdb;
    }
  }
</style>
